import { TriggerResource } from '../resources';
import { ImsObject } from './ims_object';

export const IMS_TYPE__TRIGGER = 'trigger';

export enum TriggerState {
    NORMAL = 'normal',
    DISABLED = 'disabled',
    INVALID = 'invalid',
    SNOOZED = 'snoozed',
    ALERTING = 'alerting',
    DELETED = 'deleted',
    TEMPLATE = 'template',
}

export enum TriggerAction {
    TRIPPED = 'tripped',
    NOT_TRIPPED = 'not_tripped',
    QUERY_MODIFIED = 'query_modified',
    REVALIDATE = 'revalidate',
    DISABLE = 'disable',
    UNSNOOZE = 'unsnooze',
    SNOOZE = 'snooze',
    ENABLE = 'enable',
    ACKNOWLEDGE = 'acknowledge',
    INVALIDATE = 'invalidate',
    DELETE = 'delete',
    RESTORE = 'restore',
}

const TRIGGER_DEFAULT_SORT_ORDERY_BY_STATE = {
    [TriggerState.ALERTING]: 1,
    [TriggerState.INVALID]: 2,
    [TriggerState.NORMAL]: 3,
    [TriggerState.SNOOZED]: 4,
    [TriggerState.DISABLED]: 5,
    [TriggerState.DELETED]: 6,
};

export class Trigger extends ImsObject {
    constructor(resource = new TriggerResource()) {
        super(IMS_TYPE__TRIGGER, resource);
    }

    clone() {
        return new Trigger(new TriggerResource(this.resource));
    }

    get isDeleted() {
        return this.resource.is_deleted;
    }

    set isDeleted(deleted: boolean) {
        this.resource.is_deleted = deleted;
    }

    get conditions() {
        return this.resource.conditions;
    }

    get actions() {
        return this.resource.actions;
    }

    get groupBy() {
        return this.resource.group_by;
    }

    get timeFrame() {
        return this.resource.time_frame;
    }

    get priority(): number {
        return this.resource.priority;
    }

    get name() {
        return this.resource.name;
    }

    set name(value) {
        this.resource.name = value;
    }

    get creatorId(): number {
        return this.resource.creator_id;
    }

    set creatorId(value: number) {
        this.resource.creator_id = value;
    }

    get type() {
        return this.resource.type;
    }

    get options() {
        return this.resource.options;
    }

    get description() {
        return this.resource.description;
    }

    get defaultSortOrderByState() {
        // TODO this is used in an angular template for the ng-repeat syntax :(
        return TRIGGER_DEFAULT_SORT_ORDERY_BY_STATE[this.state];
    }

    get snoozedUntil(): string {
        return this.resource.snoozed_until;
    }

    set conditions(value) {
        this.resource.conditions = value;
    }

    set actions(value) {
        this.resource.actions = value;
    }

    set groupBy(value) {
        this.resource.group_by = value;
    }

    set timeFrame(value) {
        this.resource.time_frame = value;
    }

    set priority(value: number) {
        this.resource.priority = value;
    }

    set type(value) {
        this.resource.type = value;
    }

    set options(value) {
        this.resource.options = value;
    }

    set description(value) {
        this.resource.description = value;
    }

    get state(): TriggerState {
        return this.resource.state;
    }

    set state(value: TriggerState) {
        this.resource.state = value;
    }

    get lastUpdated() {
        return this.resource.last_updated;
    }

    /**
     * TODO: Consider turning this into a moment
     * @param {string} value
     */
    set snoozedUntil(value: string) {
        this.resource.snoozed_until = value;
    }
}
